<template>
  <div class="profile-page !p-3" id="profileSettings">
    <el-row class="!m-0">
      <el-col :xl="5" :lg="5" :md="5" :sm="10" :xs="24">
        <div
          class="profile-card text-center !pr-3 !mr-3"
          shadow="never"
          style="margin-bottom: 20px"
        >
          <div class="list-group text-left !gap-1">
            <div align="center" class="my-3">
              <img
                v-if="getUserprofilepicture && getUserprofilepicture.length > 20"
                :src="getUserprofilepicture"
                style="border-radius: 50%"
                alt="Avatar"
                width="50"
                class="inline-block"
              />
              <img
                v-else
                src="@/assets/img/avatar.svg"
                alt="Avatar"
                width="50"
                class="inline-block"
              />
            </div>
            <router-link
              :class="getClass('statistics')"
              :to="{
                name: 'statistics',
              }"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/dashboard-statistics.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Dashboard Statistics
            </router-link>
            <router-link
              :class="getClass('expiration-reminders')"
              :to="{
                name: 'expiration-reminders',
              }"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/expiration-reminders.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Expiration &amp; Reminders
            </router-link>

            <router-link
              :class="getClass('application-settings')"
              :to="{
                name: 'application-settings',
              }"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/application-setting.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Application Settings
            </router-link>

            <router-link
              :class="getClass('document-notifications')"
              :to="{
                name: 'document-notifications',
              }"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/notifications.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Notifications
            </router-link>

            <router-link
              v-if="isWorkspaceIsBusiness"
              :class="getClass('myapps-credentials')"
              :to="{
                name: 'myapps-credentials',
              }"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/my-apps.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              My Apps & Credentials
            </router-link>
            <router-link
              v-if="isWorkspaceIsBusiness"
              :class="getClass('global-filters')"
              :to="{
                name: 'global-filters',
              }"
            >
              <i class="el-icon-s-operation"></i>
              Global Filters
            </router-link>
            <router-link
              v-if="isWorkspaceIsBusiness"
              :class="getClass('app-mode-configuration')"
              :to="{
                name: 'app-mode-configuration',
              }"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/app-mode.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              App mode
            </router-link>
            <router-link
              :class="getClass('AppOwnerTransfer')"
              :to="{
                name: 'AppOwnerTransfer',
              }"
            >
              <img
                src="@/assets/img/sideMenu/inactive_icons/transfer-ownership.svg"
                alt="menu"
                class="svg w-[12px] h-[12px] !mr-[4px]"
              />
              Transfer OwnerShip
            </router-link>
            <router-link
              :class="getClass('AISettings')"
              :to="{
                name: 'AISettings',
              }"
            >
              <i class="el-icon-cpu"></i>
              AI Settings
            </router-link>
          </div>
        </div>
      </el-col>
      <el-col
        :span="getIsMobile ? 24 : 5"
        :xl="19"
        :lg="19"
        :md="19"
        :sm="19"
        :xs="24"
        class="!border rounded-xl !border-page-border !p-3"
      >
        <component :is="layout">
          <router-view :layout.sync="layout" />
        </component>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import DocumentsHelper from '@/mixins/CompanyDocumentsHelper';
  import permissionsHelper from '@/mixins/permissionsHelper';
  export default {
    name: 'ProfileBodySettings',
    data() {
      return {
        layout: 'div',
      };
    },
    mixins: [DocumentsHelper, permissionsHelper],
    mounted() {
      this.getCompanyInformation();
    },
    computed: {
      ...mapGetters('auth', [
        'getUpdateProfilePicStatus',
        'getAuthenticatedUser',
        'getupdateprofilepicture',
        'getActiveWorkspace',
      ]),
      getUserprofilepicture() {
        if (this.getupdateprofilepicture) {
          return this.getupdateprofilepicture;
        } else {
          return null;
        }
      },
      getClass() {
        return (routeName) => {
          if (routeName == this.$route.name) {
            return 'list-group-item list-group-item-action active';
          } else return 'list-group-item list-group-item-action';
        };
      },
    },
    methods: {
      goBack() {
        this.$router.push({
          path: '/',
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .profile-page {
    .profile-card {
      border-radius: 12px;
      border: 1px solid var(--card-border);
      .list-group {
        .list-group-item {
          border-radius: 0 6px 6px 0;
          padding: 0.75em;
          border: none;
          border-left: 2px solid transparent;
          color: var(--black-600);
          display: flex;
          align-items: center;
          column-gap: 3px;
          background: transparent;
          [class^='el-icon'] {
            margin-right: 10px;
          }
          &.active {
            .svg {
              fill: var(--brand-500) !important;
              stroke: var(--brand-500) !important;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 767px) {
    .el-button {
      margin-top: 10px;
    }
  }
</style>
